import React, {useCallback, useEffect, useState} from 'react'
import {CFComponentProps} from 'module/CustomField/type/CFComponentType'
import {CustomFieldFileComponent} from 'module/CustomField/component/input/CustomFieldFileComponent'
import {CFMember} from 'module/CustomField/type/CFType'
import {AttachmentFetchMode} from 'generated/JavaTO'
import {fetchCFLinkAPI} from 'module/BSEntry/BSRestAPI'
import {BSAttr} from 'module/BSEntry/BSAttr'

const noop = () => {
}

export function CustomFieldFileLinkComponent(props: CFComponentProps<CFMember>) {
	const {cfDef, pos, model, modelValue} = props
	const {bookingType, hourCategory} = model || {}
	const [loading, setLoading] = useState<boolean>(false)
	const [file, setFile] = useState<CFMember | undefined>()
	const [preview, setPreview] = useState<CFMember | undefined>()
	const modelId = BSAttr.getId(model)
	const persNr = !modelId && model.persNr || undefined
	const sisName = model.sisName
	const dstField = cfDef.dstField

	useEffect(() => {
		if (sisName) {
			setLoading(true)
			fetchCFLinkAPI(
				sisName,
				modelId,
				dstField,
				pos,
				AttachmentFetchMode.PREVIEW,
				bookingType,
				hourCategory,
				persNr,
			).then(b => {
				setLoading(false)
				setPreview(b)
			})
		}
	}, [modelValue, sisName, modelId, dstField, pos])

	const fetchEager = useCallback(() => {
		if (sisName) {
			setLoading(true)
			fetchCFLinkAPI(
				sisName,
				modelId,
				dstField,
				pos,
				AttachmentFetchMode.EAGER,
				bookingType,
				hourCategory,
				persNr,
			).then(f => {
				setLoading(false)
				setFile(f)
			})
		}
	}, [modelValue, sisName, modelId, dstField, pos])

	return <CustomFieldFileComponent
		cfDef={cfDef}
		pos={pos}
		model={model}
		fetchCb={fetchEager}
		setCb={noop}
		removeCb={noop}
		disabled={true}
		modes={['file']}
		loading={loading}
		hasData={modelValue != null}
		mimeType={file?.mimeType || preview?.mimeType}
		filename={file?.filename || preview?.filename}
		data={file?.data}
		preview={preview?.preview}
	/>
}